import { makeUseFetchOne } from '@elentari/core/hooks/makeUseFetchOne'
import { UnidadeNegocioDetail } from '../types'
import { unidadeNegocioRepository } from './unidadeNegocioRepository'

export const useUnidadeNegocio = makeUseFetchOne<UnidadeNegocioDetail, string>({
  fetch: unidadeNegocioRepository.fetchOne
})
